import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import {
  ENV_CI_RELEASE,
  ENV_NAME,
  ENV_SENTRY_DSN,
  IS_DEV,
  IS_PRODUCTION,
  IS_STAGE,
} from 'common/constants/env.constants.ts';

export const initSentry = (): void => {

  if (IS_PRODUCTION || IS_STAGE || IS_DEV) {
    Sentry.init({
      dsn: ENV_SENTRY_DSN,
      release: ENV_CI_RELEASE,
      environment: ENV_NAME,
      normalizeDepth: 30,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 1.0,
      replaysOnErrorSampleRate: 1.0,
      profilesSampleRate: 1.0,
      debug: false,
      beforeSendTransaction: (event) => {
        // The interactive-flow recursive walker intentionally makes sequential HTTP requests
        // to follow server-driven redirects. Strip those spans so Sentry's "Consecutive HTTP"
        // detector doesn't raise a false-positive performance issue for each transaction UUID.
        if (event.transaction?.includes('/interactive-flow') && event.spans) {
          return {
            ...event,
            spans: event.spans.filter((span) => {
              const { op, description } = span as unknown as { op?: string; description?: string };
              return !(op?.startsWith('http') && description?.includes('/sep0024/transactions/next/interactive/'));
            }),
          };
        }
        return event;
      },
    });
  }
};
